$(document).ready(function(){
  $('.featured-collections__slider').slick({
    arrows: true,
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<div class="arrow-left"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_219_1385)"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.6569 0.92888L0.2929 7.29284C-0.097599 7.68337 -0.097599 8.31653 0.2929 8.70706L6.6569 15.071C7.0474 15.4615 7.6805 15.4615 8.07107 15.071C8.46159 14.6805 8.46159 14.0473 8.07107 13.6568L4.2678 9.8535C3.9528 9.53852 4.1759 8.99995 4.6213 8.99995H17C17.5523 8.99995 18 8.55223 18 7.99995C18 7.44766 17.5523 6.99995 17 6.99995H4.6213C4.1759 6.99995 3.9528 6.46138 4.2678 6.14639L8.07107 2.34309C8.46159 1.95257 8.46159 1.3194 8.07107 0.928879C7.6805 0.538355 7.0474 0.538355 6.6569 0.92888Z" fill="#3D3D3D"/></g><defs><clipPath id="clip0_219_1385"><rect width="18" height="16" fill="white" transform="matrix(-1 0 0 1 18 0)"/></clipPath></defs></svg></div>',
    nextArrow: '<div class="arrow-right"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_219_1383)"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.3431 0.92888L17.7071 7.29284C18.0976 7.68337 18.0976 8.31653 17.7071 8.70706L11.3431 15.071C10.9526 15.4615 10.3195 15.4615 9.92893 15.071C9.53841 14.6805 9.53841 14.0473 9.92893 13.6568L13.7322 9.8535C14.0472 9.53852 13.8241 8.99995 13.3787 8.99995H1C0.447715 8.99995 -4.8282e-08 8.55223 0 7.99995C4.8282e-08 7.44766 0.447716 6.99995 1 6.99995H13.3787C13.8241 6.99995 14.0472 6.46138 13.7322 6.14639L9.92893 2.34309C9.53841 1.95257 9.53841 1.3194 9.92893 0.928879C10.3195 0.538355 10.9526 0.538355 11.3431 0.92888Z" fill="#3D3D3D"/></g><defs><clipPath id="clip0_219_1383"><rect width="18" height="16" fill="white"/></clipPath></defs></svg></div>',                                      
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 750,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(".featured-collections__nav .nav-item_title").click(function(){
    var collection = $(this).data("collection");
    if(typeof collection != "undefined" && collection != ''){
      $(".featured-collections__nav .nav-item").removeClass("active");
      $(".featured-collections__slider").hide();
      $(this).parent().addClass("active");
      $("#"+collection+"__slider.featured-collections__slider").show();
      $("#"+collection+"__slider.featured-collections__slider").slick("slickAdd");
    }
  });

  // $('.instafeed__slider').slick({
  //   arrows: false,
  //   dots: false,
  //   infinite: true,
  //   centerMode: true,
  //   centerPadding: '100px',
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 3
  //       }
  //     },
  //     {
  //       breakpoint: 750,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });

  $(".product-media__slider").slick({
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            dots: true
          }
        }
      ]
  });
  $(".product-media__arrow.arrow-left").click(function(){
    $(".product-media__slider").slick("slickPrev");
  });
  $(".product-media__arrow.arrow-right").click(function(){
    $(".product-media__slider").slick("slickNext");
  });
  $(".product-media__slider").on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var i = nextSlide + 1;
    $(".product-media__nav-dots span").removeClass("active");
    $(".product-media__nav-dots span[data-index='"+i+"']").addClass("active");
  });
  $(".product-media__nav-dots span").click(function(){
    var i = $(this).data("index");
    $(".product-media__slider").slick("slickGoTo", i-1);
  });

  if($(window).width() < 750){
    $(".text-column__slider").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    
    $(".icon-with-text__column-wrapper").slick({
      dots: false,
      arrows: false,
      infinite: true,
      centerMode: true,
      centerPadding: '90px',
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  $(".cart-drawer__product-related").slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1
  });

  $(".header__menu-cart").click(function(){
    $("cart-drawer").toggleClass("active");
  });

  $(".blog-articles.has-loadmore .blog-articles__article").slice(0, 5).show();
    $(".blog-articles__loadmore .button").on('click', function (e) {
        e.preventDefault();
        $(".blog-articles.has-loadmore .blog-articles__article:hidden").slice(0, 4).slideDown();
        if ($(".blog-articles.has-loadmore .blog-articles__article:hidden").length == 0) {
            $(".blog-articles__loadmore .button").fadeOut('slow');
        }
    });

  if ($('#agegate-popup').length) {
    if(typeof $.cookie('age') === 'undefined' || $.cookie('age') != 'checked'){
      $.magnificPopup.open({
        items: {
          src: '#agegate-popup' 
        },
        type: 'inline',
        closeOnBgClick: false,
        showCloseBtn: false,
        callbacks: {
          open: function() {
            $("#accept_age_gate").click(function(){
              $.cookie('age', 'checked', { expires: 1 });
              $.magnificPopup.close();
            });
            $("#refuse_age_gate").click(function(){
              $("#agegate-popup .agegate-logo, #agegate-popup .agegate-info-error").show();
            });
          }
        }
      });
    }
  }

  $(".cart__agecheck").click(function(){
    if ($(this).find('input').is(':checked')) {
      $(this).find('input').prop('checked', false);
    }else{
      $(this).find('input').prop('checked', true);
    }
  });

  if($.cookie('agecheck') == 'true'){
    $(".cart__agecheck input").prop('checked', true);
  }

  $('body').on('click', '.cart__footer .cart__checkout-button', function() {
      if ($('#agecheck').is(':checked')) {
        $.cookie('agecheck', 'true', { expires: 1 });
        $(this).submit();
      }else {
        $.removeCookie('agecheck');
        alert("You must confirm that you are over 18 years old.");
        return false;
      }
  });

  $('body').on('click', '.drawer__footer .cart__checkout-button', function() {
      if ($('#cart-drawer__agecheck').is(':checked')) {
        $.cookie('agecheck', 'true', { expires: 1 });
        $(this).submit();
      }else {
        $.removeCookie('agecheck');
        alert("You must confirm that you are over 18 years old.");
        return false;
      }
  });

  var product_media_width = $(".product-media__slider").width();
  $(".product-media__slider .product-media__item").css("height", product_media_width+"px");
});

$(window).resize(function(){
  var product_media_width = $(".product-media__slider").width();
  $(".product-media__slider .product-media__item").css("height", product_media_width+"px");
});